import { GQLTestType, GQLSex, GQLKyofukuMemberType, GQLChueiBankMemberType, GQLAcquisitionFrom, GQLPaymentMethod } from '../generated/graphql'
import { ValueOf } from '../utils/type-utils'

export const testTypeLabel: Record<ValueOf<typeof GQLTestType>, string> = {
  [GQLTestType.ChueiBank]: '中栄信用金庫',
  [GQLTestType.Kyofuku]: '神奈川県教育福祉振興会',
  [GQLTestType.MbClub]: 'MBクラブ',
  [GQLTestType.OldStandardMb]: '(旧)スタンダードMB',
  [GQLTestType.OldTriallMb]: '(旧)トライアルMB',
  [GQLTestType.OldTrialMbWithCohort]: '(旧)トライアルMBコホート',
  [GQLTestType.Promotion]: '各種イベントクーポンコードコース',
  [GQLTestType.Riebe]: 'RIEBE会員特別コース',
  [GQLTestType.StandardFree]: 'スタンダードフリー（一般検査コース）',
  [GQLTestType.StandardFreeLp]: 'スタンダードフリー（一般検査コース）現地決済',
  [GQLTestType.StandardMb]: 'スタンダードMB（コホート研究参加コース）',
	[GQLTestType.SapporoChusho]: '公財 札幌市中小企業共済センター（さぽーとさっぽろ）会員',
	[GQLTestType.BohseiMb]: '株式会社望星薬局社員の方 スタンダードMB',
	[GQLTestType.BohseiFree]: '株式会社望星薬局社員の方 スタンダードフリー',
	[GQLTestType.Insurance]: '保険会社からご紹介を受けた方',
  [GQLTestType.Genovision]: 'Genovision®会員の方',
	[GQLTestType.ReloClub]: '福利厚生俱楽部・クラブオフアライアンスの会員の方',
	[GQLTestType.Benefit]: 'ベネフィット',
	[GQLTestType.GoldenLoop]: 'ゴールデンループ読者、およびご紹介の方',
	[GQLTestType.Coupon]: 'クーポンコードをお持ちの方'
}

export const sexLabel: Record<ValueOf<typeof GQLSex>, string> = {
	[GQLSex.Male]: '男',
	[GQLSex.Female]: '女'
}
export const kyofukuMemberTypeLabel: Record<ValueOf<typeof GQLKyofukuMemberType>, string> = {
	[GQLKyofukuMemberType.Current]: '現職会員',
	[GQLKyofukuMemberType.Continuation]: '継続会員',
	[GQLKyofukuMemberType.Companion]: '会員同行者',
	[GQLKyofukuMemberType.Current2]: '現職会員61歳以上'
}

export const chueiBankMemberTypeLabel: Record<ValueOf<typeof GQLChueiBankMemberType>, string> = {
	[GQLChueiBankMemberType.Nenkin]: '「ねんきん友の会」会員',
	[GQLChueiBankMemberType.Syokuiki]: '「職域サポート」会員'
}

export const acquisitionFormLabel: Record<ValueOf<typeof GQLAcquisitionFrom>, string> = {
	[GQLAcquisitionFrom.OtherAd]: '雑誌、フリーペーパー、新聞などの広告',
	[GQLAcquisitionFrom.Introduce]: '知人などの紹介',
	[GQLAcquisitionFrom.WebAd]: 'Web広告（Googleなど）',
	[GQLAcquisitionFrom.Media]: 'ラジオやテレビ、youtube',
	[GQLAcquisitionFrom.PaperAd]: '新聞、フリーペーパーなど紙広告',
	[GQLAcquisitionFrom.WebSite]: 'ブログや情報系のWEBサイト',
	[GQLAcquisitionFrom.RadioOrTvOrYoutube]: 'ラジオやテレビ、YouTube',
	[GQLAcquisitionFrom.WebSearch]: 'Google検索で初めて知った',
	[GQLAcquisitionFrom.Other]: 'その他',
	[GQLAcquisitionFrom.HospitalOrClinic]: '病院またはクリニック',
	[GQLAcquisitionFrom.MailFromRenatech]: 'レナテックからのハガキ・封書',
	[GQLAcquisitionFrom.EmailFromRenatech]: 'レナテックからの電子メール'
}

export const paymentMethodLabel: Record<ValueOf<typeof GQLPaymentMethod>, string> = {
	[GQLPaymentMethod.Debit]: '現金',
	[GQLPaymentMethod.Credit]: 'クレジットカード'
}

export const GenovisionTypeLabel: Record<number, string> = {
	1: 'Genovision会員ご本人さま',
	2: 'ご紹介の方'
}

export const GoldenLoopTypeLabel: Record<number, string> = {
	1: 'ゴールデンループ読者ご本人さま',
	2: 'ご紹介の方'
}
